import { createVNode as n, h as c, render as l } from "vue";
import o from "./Toasts.js";
const s = "stash-toasts-mount-node", r = {
  install(m, e) {
    const d = (e == null ? void 0 : e.mountNodeId) || s;
    let t = document.getElementById(d);
    t || (t = document.createElement("div"), t.id = d, t.dataset.test = s, document.body.appendChild(t)), e != null && e.mountNodeClass && !t.classList.contains(e.mountNodeClass) && t.classList.add(e.mountNodeClass);
    const a = n(c(o));
    a.appContext = m._context, l(a, t);
  }
};
export {
  s as DEFAULT_TOASTS_PLUGIN_NODE_ID,
  r as default
};
//# sourceMappingURL=ToastsPlugin.js.map
